/**
 * Заповнювач поля «Пароль» у Development (прототип v4 показує 8 крапок демо-пароля). Це не пароль: у Development сервер не перевіряє пароль
 * демо-облікових записів (схема Dev), справжні паролі ніде не публікуються (Issue 003); у продуктиві поле порожнє.
 */
export const devPasswordStub = '••••••••';
